/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Info({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M5.4 6.4a.6.6 0 0 1 .6-.6h2a.6.6 0 0 1 .6.6v5.3H11a.6.6 0 1 1 0 1.2H5a.6.6 0 1 1 0-1.2h2.4V7H6a.6.6 0 0 1-.6-.6" clipRule="evenodd" /><path fill="currentColor" d="M8 3a.9.9 0 1 0 0 1.8A.9.9 0 0 0 8 3" /></svg>;
}
;